export default "20260601.1 \r\n"